import React from "react";
import { Layout } from "views/common/Layout";
import { Check } from "lucide-react";

export const SubmitSuccess = () => {
    return (
        <Layout>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
                <div className="mx-auto max-w-3xl">
                    <div className="text-center">
                        <div className="flex justify-center">
                            <Check className="h-16 w-16 text-green-500" />
                        </div>
                        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                            Submission Successful!
                        </h1>
                        <p className="mt-4 text-lg text-gray-600">
                            Thank you for submitting your tool. We'll review
                            your submission and get back to you soon.
                        </p>
                    </div>

                    <div className="mt-12 bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
                        <h2 className="text-xl font-semibold text-gray-900 mb-4">
                            What happens next?
                        </h2>
                        <ul className="space-y-4 text-gray-600">
                            <li className="flex items-start">
                                <span className="flex-shrink-0 h-6 w-6 text-blue-500">
                                    1.
                                </span>
                                <span className="ml-2">
                                    We'll review your submission within 2-3
                                    business days
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 h-6 w-6 text-blue-500">
                                    2.
                                </span>
                                <span className="ml-2">
                                    You'll receive an email notification once
                                    your tool is approved
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 h-6 w-6 text-blue-500">
                                    3.
                                </span>
                                <span className="ml-2">
                                    Your tool will be listed on our platform and
                                    visible to our community
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div className="mt-8 text-center">
                        <a
                            href="/"
                            className="inline-flex items-center rounded-lg bg-blue-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            Return to Home
                        </a>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
